import { apiFetch, API_URL, obterToken } from './apiClient';

/* protótipo local, sempre em modo simulação (nunca transmite de verdade) */
export const testarEmissao = (clienteId, pedido) => apiFetch('/nf/emitir-teste', {
  method: 'POST',
  body: JSON.stringify({ clienteId, pedido }),
});

/* emissão REAL — transmite pra Producao de verdade, vira nota fiscal com efeito legal */
export const emitirNota = (clienteId, pedido) => apiFetch('/nf/emitir', {
  method: 'POST',
  body: JSON.stringify({ clienteId, pedido }),
});

/* próximo número de DPS e status do certificado deste cliente (prestador) */
export const buscarParametrosNf = (clienteId) => apiFetch(`/nf/parametros/${clienteId}`);
export const descreverCodigoMunicipal = (corpo) => apiFetch('/nf/codigos-municipais/descricao', { method: 'PUT', body: JSON.stringify(corpo) });
/* alíquota do Simples mês a mês (histórico + a do mês corrente) */
export const buscarAliquotaSimples = (clienteId) => apiFetch(`/nf/aliquota-simples/${clienteId}`);
export const registrarAliquotaSimples = (clienteId, corpo) => apiFetch(`/nf/aliquota-simples/${clienteId}`, { method: 'POST', body: JSON.stringify(corpo) });
/* complementos municipais (cTribMun) aceitos pelo município pro código nacional */
export const buscarCodigosMunicipais = (clienteId, ctn, municipio, atualizar) =>
  apiFetch(`/nf/codigos-municipais/${clienteId}?ctn=${ctn}${municipio ? `&municipio=${municipio}` : ''}${atualizar ? '&atualizar=1' : ''}`);

export const listarNotasEmitidas = (clienteId) => apiFetch(`/nf/notas/${clienteId}`);

export async function enviarCertificadoNf(clienteId, arquivo, senha) {
  const token = obterToken();

  const form = new FormData();
  form.append('arquivo', arquivo);
  if (senha) form.append('senha', senha);

  const response = await fetch(`${API_URL}/nf/certificado/${clienteId}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await response.json();
  if (!response.ok) throw new Error(json.error || 'Erro ao enviar certificado');
  return json;
}

/* PDF de conferência antes de emitir: mesmo pedido do /emitir, nada é
   assinado nem transmitido */
export async function previaDanfse(clienteId, pedido) {
  const token = obterToken();
  const response = await fetch(`${API_URL}/nf/previa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ clienteId, pedido }),
  });
  if (!response.ok) {
    let mensagem = 'Não foi possível montar a prévia';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }
  return response.blob();
}

/* baixa o PDF (DANFSe) de uma NFS-e já autorizada, pela chave de acesso */
export async function baixarDanfse(clienteId, chaveAcesso, ambiente = 1) {
  const token = obterToken();

  const response = await fetch(`${API_URL}/nf/danfse/${clienteId}/${chaveAcesso}?ambiente=${ambiente}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    let mensagem = 'Erro ao baixar o PDF';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }
  return response.blob();
}

/* baixa o XML da NFS-e autorizada -- o backend serve a cópia guardada na
   emissão e, se não tiver, busca na Sefin Nacional (que fica de pé mesmo
   quando a ADN do PDF cai) */
export async function baixarXmlNota(clienteId, chaveAcesso, ambiente = 1) {
  const token = obterToken();

  const response = await fetch(`${API_URL}/nf/xml/${clienteId}/${chaveAcesso}?ambiente=${ambiente}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    let mensagem = 'Erro ao baixar o XML';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }
  return response.blob();
}

/* notas de TODOS os clientes num período (tela Emitidas). Sem período, o
   backend assume o mês corrente. */
export function listarNotasPeriodo({ de, ate, clienteId } = {}) {
  const q = new URLSearchParams();
  if (de) q.set('de', de);
  if (ate) q.set('ate', ate);
  if (clienteId) q.set('clienteId', clienteId);
  return apiFetch(`/nf/notas${q.toString() ? `?${q}` : ''}`);
}

/* várias notas de uma vez, num .zip com uma pasta por cliente */
export async function baixarNotasEmLote(chaves, formatos = ['xml']) {
  const token = obterToken();

  const response = await fetch(`${API_URL}/nf/notas/baixar-lote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ chaves, formatos }),
  });
  if (!response.ok) {
    let mensagem = 'Erro ao baixar as notas';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }
  return response.blob();
}

/* Cancelamento da NFS-e (evento e101101 na Receita). Irreversível: a nota
   não some, passa a constar como cancelada. */
export const cancelarNotaFiscal = (chaveAcesso, { cMotivo, xMotivo }) =>
  apiFetch(`/nf/notas/${chaveAcesso}/cancelar`, {
    method: 'POST',
    body: JSON.stringify({ cMotivo, xMotivo }),
  });

/* consulta o CNPJ no cadastro da Receita (via backend, que cuida do cache
   e do provedor reserva) -- conveniência pra não digitar tudo à mão */
export const consultarCnpj = (documento) =>
  apiFetch(`/nf-tomadores/consultar-cnpj/${String(documento).replace(/\D/g, '')}`);
